import axios from 'axios';

/**
 * /health живёт вне префикса /api: его опрашивают Caddy и внешний аптайм-чекер.
 * Здесь он нужен как проверка, что фронтенд и API действительно связаны.
 */
export async function fetchApiLiveness(): Promise<boolean> {
  const response = await axios.get('/health', { timeout: 5_000 });
  return response.status === 200;
}
